import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const DisplayIdSchema = z.string().brand('display-id')
export type DisplayId = ZodInfer<typeof DisplayIdSchema>

export const DisplayId = (id: string = generateRandomString(8)): DisplayId => {
  return DisplayIdSchema.parse(id)
}
